// This file is compiled inside Decidim core pack. Code can be added here and will be executed
// as part of that pack

// Load images
require.context("../../images", true)

$(document).on('on:toggle', function (e,i) {
    if ($('form.form.answer-questionnaire button[data-toggle]').length > 0) {
        $("html, body").animate({
            scrollTop: $('header').height()
        }, 100);
    }
})